import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginRegisterSobek from './components/LoginRegisterSobek';
import ProfileSobek from './components/ProfileSobek';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginRegisterSobek />} />
      <Route path="/profile" element={<ProfileSobek />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
